import { useState, useEffect } from 'react';
import axios from "axios";
import { useDispatch } from 'react-redux'
import { appActions } from './Store/store'
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const logout = () => {
    localStorage.removeItem('insuranceUser');
    setIsAuthenticated(false)
    dispatch(appActions.resetState())
    navigate('/')
  }

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        const user = localStorage.getItem('insuranceUser');
        const user_info = JSON.parse(user);
        if (!user) {
          logout()
          return
        }

        const response = await axios.post('/auth/validateToken', {}, {
          headers: { 'Authorization': 'Bearer ' + JSON.parse(user).token }
        });

        if (response.status === 200) {

          if (user_info.permissions[0] === "*") {
            console.log("hey from protected route")
            setIsAuthenticated(true)
            dispatch(appActions.addUser(JSON.parse(user)))

          }
          else {
            logout()
            setIsAuthenticated(false)
          }

        }
      } catch (error) {
        if (error.response.status === 401) {
          logout()
        }
      }
    };

    authenticateUser()
  }, [])

  return (
    <>
      {isAuthenticated && children}

    </>
  );
};

export default ProtectedRoute;
